import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export function LegalPage({ title, subtitle, updated, sections, testid }) {
  const [c, setC] = useState({ company_name: "RightPay", phone: "(336) 517-3744", email: "cs@encorebusiness.co", address: "3 Centerview Dr., Ste 300, Greensboro, NC 27407" });
  useEffect(() => { api.get("/site/contact").then((r) => setC(r.data)).catch(() => {}); window.scrollTo(0, 0); }, []);
  const fill = (t) => t.replaceAll("{company}", c.company_name).replaceAll("{email}", c.email).replaceAll("{phone}", c.phone).replaceAll("{address}", c.address);
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid={testid}>
      <header className="border-b border-slate-100">
        <div className="max-w-4xl mx-auto px-5 h-16 flex items-center justify-between">
          <Link to="/"><img src="/rightpay-logo.png" alt="RightPay" className="h-10 w-auto object-contain" /></Link>
          <Link to="/" className="text-sm font-medium text-slate-600 hover:text-blue-700 inline-flex items-center gap-1" data-testid="legal-back"><ArrowLeft className="w-4 h-4" /> Back to site</Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-12 sm:py-16">
        <span className="text-xs font-bold tracking-wider uppercase text-blue-700">{subtitle}</span>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight mt-2">{title}</h1>
        <p className="text-sm text-slate-500 mt-2">Last updated {updated}</p>
        <div className="mt-10 space-y-8">
          {sections.map(([h, body], i) => (
            <section key={h} data-testid={`legal-section-${i}`}>
              <h2 className="font-display font-bold text-lg text-slate-900">{i + 1}. {h}</h2>
              {Array.isArray(body) ? <ul className="mt-2 space-y-1.5 text-slate-600 text-sm leading-relaxed list-disc pl-5">{body.map((b, j) => <li key={j}>{fill(b)}</li>)}</ul> : <p className="mt-2 text-slate-600 text-sm leading-relaxed whitespace-pre-line">{fill(body)}</p>}
            </section>
          ))}
        </div>
        <div className="mt-12 rounded-2xl bg-slate-50 border border-slate-200 p-5 text-sm text-slate-600" data-testid="legal-contact">
          <div className="font-semibold text-slate-900">Questions about this policy?</div>
          <div className="mt-1">{c.company_name}, a division of Encore Business Services Group LLC · {c.address}</div>
          <div><a href={`mailto:${c.email}`} className="text-blue-700 hover:underline">{c.email}</a> · <a href={`tel:${c.phone.replace(/\D/g, "")}`} className="text-blue-700 hover:underline">{formatPhone(c.phone)}</a></div>
        </div>
      </main>
      <footer className="border-t border-slate-100 py-8 text-center text-xs text-slate-500">
        <nav className="flex justify-center gap-6 mb-3"><Link to="/policies" className="hover:text-slate-900">Policies &amp; Procedures</Link><Link to="/privacy" className="hover:text-slate-900">Privacy Policy</Link><Link to="/login" className="hover:text-slate-900">Client login</Link></nav>
        © {new Date().getFullYear()} RightPay. All rights reserved.<br />RightPay is a division of Encore Business Services Group LLC.
      </footer>
    </div>
  );
}
